import React, { useState, useEffect } from 'react';
import Config from '../Config'
import axios from 'axios';
import Pagination from '../layout/Pagination';
import { Route, Link, Switch, BrowserRouter as Router } from 'react-router-dom'
import logos from '../layout/pageheader.jpeg'
import _ from 'lodash'
//page-header
export const Knowledge = () => {

    const [posts, setPosts] = useState([]);
    const [loading, setLoading] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [postsPerPage] = useState(6);

    useEffect(() => {
        const fetchPosts = async () => {
            const res = await axios.get(new Config().BaseURL() + 'category/fetchallknowledgebase/knowledgebase');
            setPosts(res.data);
        };
        fetchPosts();
    }, []);

    const indexOfLastPost = currentPage * postsPerPage;
    const indexOfFirstPost = indexOfLastPost - postsPerPage;
    const currentPosts = posts.slice(indexOfFirstPost, indexOfLastPost);

    const paginate = pageNumber => setCurrentPage(pageNumber);
    return (
        <div>
            <div class="hero-section bg_imgs" style={{ backgroundImage: `url(${logos})` }}>
                <div class="container">
                    <div class="banner-content cl-white">
                        <ul class="breadcrumb">
                            <li><a href="#/">Home</a></li>
                            <li>Knowledge Base</li>
                        </ul>
                    </div>
                </div>
            </div>

            <div class="form-section">
                <div class="container">
                    <div class="row justify-content-center">
                        <div class="col-md-10">
                            <div class="search-wrapper mt--55--70">
                                <form class="search-form round no-border mw-925">
                                    <input type="text" placeholder="Start typing your search…" />
                                    <button type="submit"><i class="flaticon-search"></i> <span class="d-none d-sm-inline-block">Search</span></button>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>


            <section class="knowledge-section padding-bottom padding-top">
                <div class="container">
                    <div class="section-header">
                        <h2 class="title">Knowledge Base</h2>
                        <p>Explore How-To's and learn best practices from our knowledge base.</p>
                    </div>
                    <div class="row justify-content-center mb-30-none">
                        {(posts =='')?<span className='fa fa-spinner fa-spin'></span>:
                            currentPosts.map(itm =>

                                <div class="col-lg-6 col-md-10">
                                     {/* <Link  to={"/answers/" + itm.id + "/" + itm.subject.replace(/ /g, '-')}> */}
                                    <div class="knowledge-item">
                                        <div class="knowledge-thumb">
                                            <img src="./assets/images/knowledge/know1.png" alt="knowledge" />
                                        </div>
                                        <div class="knowledge-content">
                                            <h4 class="title"><a href={"#/answers/" + itm.id + "/" + itm.subject.replace(/ /g, '-')}>{itm.subject}</a></h4>
                                            <p style={{color:"#372c7a"}}>{_.truncate(itm.message, { 'length': 83, 'separator': ' '})} </p>
                                        </div>
                                    </div>
                                    {/* </Link> */}
                                </div>
                            )
                        }

                    </div>
                </div>
                <br></br>
                <span>Total Articles {posts.length}</span>
                        <Pagination
                            postsPerPage={postsPerPage}
                            totalPosts={posts.length}
                            paginate={paginate}
                        />
            </section>
            {/* <section class="popular-section padding-top padding-bottom section-bg-2">
                <div class="container">
                    <div class="section-header-2">
                        <div class="left-side">
                            <h2 class="title">Popular articles </h2>
                            <p>Discover the best of Deskoto with our Featured Articles category!</p>
                        </div>
                        <a href="#0" class="load-more small">View All Articles</a>
                    </div>
                    <div class="row justify-content-center mb-30-none">
                        <div class="col-lg-4 col-md-6">
                            <a href="knowledge-based-single.html" class="popular-item">
                                <div class="popular-thumb">
                                    <i class="flaticon-file"></i>
                                </div>
                                <div class="popular-content">
                                    <span class="info">For Freelancers</span>
                                    <p>How to withdraw money from your account</p>
                                </div>
                            </a>
                        </div>
                        <div class="col-lg-4 col-md-6">
                            <a href="knowledge-based-single.html" class="popular-item">
                                <div class="popular-thumb">
                                    <i class="flaticon-file"></i>
                                </div>
                                <div class="popular-content">
                                    <span class="info">For Freelancers</span>
                                    <p>How to withdraw money from your account</p>
                                </div>
                            </a>
                        </div>
                        <div class="col-lg-4 col-md-6">
                            <a href="knowledge-based-single.html" class="popular-item">
                                <div class="popular-thumb">
                                    <i class="flaticon-file"></i>
                                </div>
                                <div class="popular-content">
                                    <span class="info">For Companies</span>
                                    <p>How to withdraw money from your account</p>
                                </div>
                            </a>
                        </div>
                        <div class="col-lg-4 col-md-6">
                            <a href="knowledge-based-single.html" class="popular-item">
                                <div class="popular-thumb">
                                    <i class="flaticon-file"></i>
                                </div>
                                <div class="popular-content">
                                    <span class="info">Customization</span>
                                    <p>How to withdraw money from your account</p>
                                </div>
                            </a>
                        </div>
                        <div class="col-lg-4 col-md-6">
                            <a href="knowledge-based-single.html" class="popular-item">
                                <div class="popular-thumb">
                                    <i class="flaticon-file"></i>
                                </div>
                                <div class="popular-content">
                                    <span class="info">Customization</span>
                                    <p>How to withdraw money from your account</p>
                                </div>
                            </a>
                        </div>
                        <div class="col-lg-4 col-md-6">
                            <a href="knowledge-based-single.html" class="popular-item">
                                <div class="popular-thumb">
                                    <i class="flaticon-file"></i>
                                </div>
                                <div class="popular-content">
                                    <span class="info">Your Account</span>
                                    <p>How to withdraw money from your account</p>
                                </div>
                            </a>
                        </div>
                    </div>
                </div>
            </section> */}
            {/* <div class="article-overview section tint" >
                <div class="container w-container" >
                    <div class="knowledge-base-row w-row" >
                        <div class="knowledge-base-column-left w-col w-col-12">
                            <div>
                                <div class="knowledge-base-block" id="paginate" >
                                    <div class="knowledge-base-title-wrapper">
                                        <div class="knowledge-base-title">All Articles</div>
                                    </div>
                                    <div class="overall-dynamic-list-wrapper w-dyn-list">
                                        {
                                            currentPosts.map(itm =>

                                                <div class="article-item w-dyn-item">
                                                    <Link class="single-article-item-link-block w-inline-block" to={"/answers/" + itm.id + "/" + itm.subject.replace(/ /g, '-')}>
                                                        <div class="article-item-text-wrapper simple with-icon">
                                                            <div class="item-icon"></div>
                                                        </div>
                                                        <div class="article-item-text-wrapper">
                                                            <div class="single-article-title"></div>
                                                            <div class="single-article-title view" style={{ color: "black" }}>{itm.subject}</div>
                                                        </div>
                                                    </Link>
                                                </div>
                                            )
                                        }
                                        <span>Total Articles {posts.length}</span>
                                        <Pagination
                                            postsPerPage={postsPerPage}
                                            totalPosts={posts.length}
                                            paginate={paginate}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div> */}


        </div>
    )
}
